// extracted by mini-css-extract-plugin
export default {"col":"Col_col__9nmBL"};